export default __webpack_public_path__ + "Wrong Buzzer.cee93e.mp3";